export const GET_WALLET_INFO_LIST = null;
export const SELECTED_WALLET_PLAN_DETAILS = null;
export const GET_GIFT_CARD_LIST = null;
export const CONFIRM_PURCHASE_GIFT_CARD_DETAILS = null;
export const GET_GIFTCARD_INFO_LIST = null;
